import React, { useState, Fragment, useEffect } from 'react';
import add_box from '../images/add_box.svg';
import deleteImg from '../images/delete.svg';
import spanerImg from '../images/build-black-18dp.svg';
import '../styles/Addons.scss';
import "../styles/Subscription_Upgrade.scss";
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import Modal from 'react-modal';
import close_black from '../images/close-black.svg';
import loader from '../images/loader.gif';
import '../styles/CommonStyle.scss';
import { useTranslation } from 'react-i18next';
import { getAddOns } from '../services/add-on-service';


const AddOns = (props) => {
    const { t } = useTranslation();
    const [modalFields, setModalFields] = useState(
        {
            "productGuid": "string",
            "tierGuid": "string",
            "locationGuid": "string",
            "licenseCount": 0
        }
    );
    let [isModalOpen, setModal] = useState(false);
    let [isConfirmModalOpen, setConfirmModal] = useState(false);
    const [addOnList, setAddOn] = useState([]);

    useEffect(() => {
        getAddOnList();

        return () => {
        };
    }, []);

    const handleChange = (event) => {
        const value = { ...modalFields };
        value[event.target.name] = event.target.value;
        setModalFields(value);
    }

    const increment = (event) => {
        const value = { ...modalFields };
        let oldVal = value.licenseCount;
        value['licenseCount'] = oldVal + 1;
        setModalFields(value);
    }

    const decrement = (event) => {
        const value = { ...modalFields };
        let oldVal = value.licenseCount;
        if (value.licenseCount > 0) {
            value['licenseCount'] = oldVal - 1;
        }
        else {
            value['licenseCount'] = 0;
        }

        setModalFields(value);
    }

    const getAddOnList = async () => {
        try {
            let addOnList = getAddOns();
            setAddOn(addOnList);
        } catch (error) {
            console.log('getAddOnList error', error);
        }
    }

    const handleModalClose = event => {
        setModal(false);
    };

    const handleModalOpen = event => {
        setModal(true);
    };

    const handleConfirmModalClose = event => {
        setConfirmModal(false);
    };

    const handleConfirmModalOpen = event => {
        setConfirmModal(true);
    };

    function navigate() {
        props.history.push("/Payment");
    }

    // New funality navigation 

    return (
        <main className="Dash-board">
            <div className="Dash-board-div">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3">
                            <SideBar {...props} />
                        </div>
                        <div className="col-md-9">
                            <Header {...props} />
                            <div className="content-sec">
                                {
                                    (addOnList.length > 0) ? (
                                        <Fragment>
                                            <div className="purchase-content">
                                                {/* <div onClick={(e) => handleAddFields(e)} className="purchase-pack-add"><img src={add_box} alt="" />Add Another Package</div> */}

                                                <div className="purchase-text">{t('ADD-ONS')}</div>

                                                <div className="purchase-pack-add" onClick={handleModalOpen}><img src={add_box} alt="" /><span>{t('Add New Add-Ons')}</span></div>
                                            </div>


                                            <div className="added-locations">
                                                {addOnList && addOnList.map((elmt, i) =>
                                                    <div className="box" key={i}>
                                                        <div className="align-box-elmt">
                                                            <h4 className="location">{t(`${elmt.display}`)}</h4>
                                                            <div className="spaner" href="#"><img src={spanerImg} alt="" /></div>
                                                            <div onClick={handleConfirmModalOpen} className="delete" href="#"><img src={deleteImg} alt="" style={{ cursor: "pointer" }} /></div>
                                                        </div>
                                                        <h3 className="place">{elmt.OfficeName}</h3>
                                                        <h5 className="country">{t('INDIA | INR (₹)')}</h5>
                                                        <p>{t('Cras pretium suscipit libero sed faucibus. Donec velit urna, luctus elementum hendrerit euismod.')}</p>
                                                        <Modal
                                                            isOpen={isConfirmModalOpen}
                                                            onRequestClose={handleConfirmModalClose}
                                                            contentLabel="My Confirm dialog"
                                                            style={{
                                                                overlay: {
                                                                    position: 'fixed',
                                                                    top: 0,
                                                                    left: 0,
                                                                    right: 0,
                                                                    bottom: 0
                                                                },
                                                                content: {
                                                                    position: 'unset',
                                                                    top: '0px',
                                                                    left: '40px',
                                                                    right: '40px',
                                                                    bottom: '40px',
                                                                    border: 'none',
                                                                    background: 'none',
                                                                    overflow: 'hidden',
                                                                    WebkitOverflowScrolling: 'touch',
                                                                    borderRadius: '4px',
                                                                    outline: 'none',
                                                                    padding: '0px'
                                                                }
                                                            }}>
                                                            <div className="modal-dialog delete-dialog">
                                                                <div className="modal-content">
                                                                    <div className="modal-header">
                                                                        <h5 className="modal-title">{t('Are you sure you want to delete?')}</h5>
                                                                        <button type="button" className="close" onClick={handleConfirmModalClose}>
                                                                            <span><img src={close_black} alt="" /></span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <div className="row">
                                                                            <div className="col-md-12">
                                                                                <h5 className="modal-title">{t("This item will be deleted immediately. You can't undo this action.")}</h5>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" onClick={handleConfirmModalClose} className="btn btn-secondary" data-dismiss="modal">{t('CANCEL')}</button>
                                                                        <button type="submit" onClick={(e) => { this.deleteBranch(e, elmt) }} className="btn btn-primary" >{t('CONFIRM')}</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Modal>
                                                    </div>
                                                )}
                                            </div>



                                            <div className="bottom-button">
                                                <button type="button" className="btn btn-secondary" onClick={() => { props.history.push('/Location') }}>{t('BACK')}</button>
                                                <button type="button" className="btn btn-primary" onClick={navigate} >{t('NEXT')}</button>

                                            </div>
                                        </Fragment>
                                    ) : (<img src={loader} alt="" className="loader" />)

                                }
                            </div>

                        </div>

                    </div>
                </div>
                <Footer />
            </div>


            <Modal
                isOpen={isModalOpen}
                onRequestClose={handleModalClose}
                contentLabel="My dialog"
                style={{
                    overlay: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        // backgroundColor: 'rgba(0, 0, 0, 0.75)'
                    },
                    content: {
                        position: 'unset',
                        top: '0px',
                        left: '40px',
                        right: '40px',
                        bottom: '40px',
                        border: 'none',
                        background: 'none',
                        overflow: 'hidden',
                        WebkitOverflowScrolling: 'touch',
                        borderRadius: '4px',
                        outline: 'none',
                        padding: '0px'
                    }
                }}>
                <div className="modal-dialog add-new-language-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('Add New Add-Ons')}</h5>
                            <button type="button" className="close" onClick={handleModalClose}>
                                <span><img src={close_black} alt="" /></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form autoComplete="off modal-body-padding">
                                <div className="row ">
                                    <div className="col-md-7">
                                        <label className="icon">{t('Add-on Feature')}</label>
                                        <select required className="form-control" name="productGuid"
                                            onChange={handleChange}>
                                            {addOnList && addOnList.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-5 license-count-cntrl">
                                        <label>{t('Total Units Required')}:</label>

                                        <input type="text" name="licenseCount" className="form-control number-count" value={modalFields.licenseCount}
                                            id="turtle-doves" onChange={handleChange} />
                                        <div className="inc button" onClick={increment}>+</div>
                                        <div className="dec button" onClick={decrement}>-</div>
                                    </div>
                                </div>


                            </form>
                        </div>
                        <div className="modal-footer">
                            {/* <div>{t('Learn more')}</div> */}
                            <button type="button" onClick={handleModalClose} className="btn btn-secondary" data-dismiss="modal">{t('CANCEL')}</button>
                            <button type="submit" className="btn btn-primary" >{t('APPLY')}</button>
                        </div>
                    </div>
                </div>
            </Modal>

        </main>
    );
}

export default AddOns;
